import React from 'react';
import { FormikErrors, FormikHandlers, FormikTouched } from 'formik';

import { TextField } from '@mui/material';
import { PersonalDetailsValues } from '../PersonalDetailsStep';
import { useLanguage } from '../../../../../../common/GeneralUtils';
import { CustomPersonalDetailData } from '../../../../../../api';

type RenderMultilineDetailProps = {
  customPersonalDetail: CustomPersonalDetailData;
  handleChange: FormikHandlers['handleChange'];
  values: PersonalDetailsValues;
  touched?: FormikTouched<PersonalDetailsValues>;
  errors?: FormikErrors<PersonalDetailsValues>;
};
export const RenderMultilineDetail = ({
  customPersonalDetail,
  handleChange,
  values,
  touched,
  errors,
}: RenderMultilineDetailProps) => {
  const language = useLanguage();
  // @ts-ignore
  const value = values.custom_personal_details[customPersonalDetail.id];
  // @ts-ignore
  const fieldTouched = touched?.custom_personal_details?.[customPersonalDetail.id];
  // @ts-ignore
  const fieldError = errors?.custom_personal_details?.[customPersonalDetail.id];

  return (
    <TextField
      fullWidth
      className="text-field"
      id={customPersonalDetail.id}
      name={`custom_personal_details.${customPersonalDetail.id}`}
      label={customPersonalDetail.label[language]}
      value={value}
      placeholder={customPersonalDetail.label[language]}
      onChange={handleChange}
      multiline
      error={fieldTouched && Boolean(fieldError)}
      helperText={fieldTouched && (fieldError as string)}
    />
  );
};
